import { render, staticRenderFns } from "./TrendyolProductSearch.vue?vue&type=template&id=f8e996b4&"
import script from "./TrendyolProductSearch.vue?vue&type=script&lang=js&"
export * from "./TrendyolProductSearch.vue?vue&type=script&lang=js&"
import style0 from "./TrendyolProductSearch.vue?vue&type=style&index=0&id=f8e996b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports